import * as i0 from '@angular/core';
import { Directive, signal, ViewChild, Inject, ChangeDetectionStrategy, Component, Injectable, model } from '@angular/core';
import { map, lastValueFrom, EMPTY, of, catchError, shareReplay } from 'rxjs';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import * as i3 from '@ngx-translate/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import * as i2 from '@angular/material/snack-bar';
function GenericDialogComponent_ng_template_1_Template(rf, ctx) {}
function GenericDialogComponent_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r2.icon);
  }
}
function GenericDialogComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function GenericDialogComponent_For_4_Template_button_click_0_listener() {
      const button_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onButtonAction(button_r2.id));
    });
    i0.ɵɵtemplate(1, GenericDialogComponent_For_4_Conditional_1_Template, 2, 1, "mat-icon");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵproperty("disabled", button_r2.disabled());
    i0.ɵɵadvance();
    i0.ɵɵconditional(button_r2.icon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, button_r2.text), " ");
  }
}
function FavouriteStarComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 2);
    i0.ɵɵlistener("click", function FavouriteStarComponent_Conditional_0_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeValue());
    });
    i0.ɵɵtext(1, " star_border ");
    i0.ɵɵelementEnd();
  }
}
function FavouriteStarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 3);
    i0.ɵɵlistener("click", function FavouriteStarComponent_Conditional_1_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changeValue());
    });
    i0.ɵɵtext(1, " star ");
    i0.ɵɵelementEnd();
  }
}
let GenericDialogContentDirective = /*#__PURE__*/(() => {
  class GenericDialogContentDirective {
    constructor(viewContainerRef) {
      this.viewContainerRef = viewContainerRef;
    }
    static {
      this.ɵfac = function GenericDialogContentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GenericDialogContentDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: GenericDialogContentDirective,
        selectors: [["", "appGenericDialogContent", ""]]
      });
    }
  }
  return GenericDialogContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class GenericDialogData {}
;
let GenericDialogComponent = /*#__PURE__*/(() => {
  class GenericDialogComponent {
    set appGenericDialogContent(value) {
      if (!value) return;
      const viewContainerRef = value.viewContainerRef;
      viewContainerRef.clear();
      this._ComponentRef = viewContainerRef.createComponent(this.data.componentType);
      const buttons = [];
      for (const button of this.data.buttons ?? this._ComponentRef.instance.getDialogButtons()) {
        buttons.push({
          id: typeof button == "string" ? button : button.text,
          text: typeof button == "string" ? button : button.text,
          icon: typeof button == "string" ? undefined : button.icon,
          disabled: signal(typeof button == "string" ? false : button.disabled ?? false)
        });
      }
      this.buttons.set(buttons);
      this._ComponentRef.instance.setDialogRef(this.dialogRef);
      this._ComponentRef.instance.setDialogData(this.data.data);
    }
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.buttons = signal([]);
    }
    disableButton(button, disabled) {
      let buttonObj = this.buttons().find(x => x.id == button);
      if (buttonObj) buttonObj.disabled.set(disabled);
    }
    onButtonAction(button) {
      this._ComponentRef.instance.buttonPressed(button);
    }
    static {
      this.ɵfac = function GenericDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GenericDialogComponent)(i0.ɵɵdirectiveInject(i1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GenericDialogComponent,
        selectors: [["ng-component"]],
        viewQuery: function GenericDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(GenericDialogContentDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appGenericDialogContent = _t.first);
          }
        },
        decls: 5,
        vars: 4,
        consts: [["mat-dialog-content", ""], ["appGenericDialogContent", ""], ["mat-dialog-actions", "", 3, "align"], ["mat-button", "", 3, "disabled"], ["mat-button", "", 3, "click", "disabled"]],
        template: function GenericDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, GenericDialogComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵrepeaterCreate(3, GenericDialogComponent_For_4_Template, 4, 5, "button", 3, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.data.customClasses);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("align", ctx.data.buttonAlign);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.buttons());
          }
        },
        dependencies: [MatDialogModule, i1.MatDialogActions, i1.MatDialogContent, GenericDialogContentDirective, MatButton, TranslatePipe, MatIcon],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return GenericDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GenericOkDialogComponent = /*#__PURE__*/(() => {
  class GenericOkDialogComponent {
    constructor(data) {
      this.data = data;
      data.message = data.message.replace(/(?:\r\n|\r|\n|\\n)/g, "<br>");
    }
    static {
      this.ɵfac = function GenericOkDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GenericOkDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GenericOkDialogComponent,
        selectors: [["ng-component"]],
        decls: 9,
        vars: 11,
        consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 2, "white-space", "pre-line", 3, "innerHTML"], ["mat-dialog-actions", "", "align", "end"], ["mat-button", "", "cdkFocusInitial", "", 3, "mat-dialog-close"]],
        template: function GenericOkDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "div", 1);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementStart(5, "div", 2)(6, "button", 3);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 4, ctx.data.title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 6, ctx.data.message, ctx.data.formatData), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", true);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 9, "t_ok"));
          }
        },
        dependencies: [MatDialogModule, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, MatButton, TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return GenericOkDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GenericYesnoDialogComponent = /*#__PURE__*/(() => {
  class GenericYesnoDialogComponent {
    constructor(data) {
      this.data = data;
      data.message = data.message.replace(/(?:\r\n|\r|\n|\\n)/g, "<br>");
    }
    static {
      this.ɵfac = function GenericYesnoDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GenericYesnoDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: GenericYesnoDialogComponent,
        selectors: [["ng-component"]],
        decls: 12,
        vars: 15,
        consts: [["mat-dialog-title", ""], ["mat-dialog-content", "", 2, "white-space", "pre-line", 3, "innerHTML"], ["mat-dialog-actions", "", "align", "end"], ["mat-button", "", "cdkFocusInitial", "", 3, "mat-dialog-close"]],
        template: function GenericYesnoDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "div", 1);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementStart(5, "div", 2)(6, "button", 3);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "button", 3);
            i0.ɵɵtext(10);
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 6, ctx.data.title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 8, ctx.data.message, ctx.data.formatData), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", false);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 11, "t_no"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", true);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 13, "t_yes"));
          }
        },
        dependencies: [MatDialogModule, i1.MatDialogClose, i1.MatDialogTitle, i1.MatDialogActions, i1.MatDialogContent, MatButton, TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return GenericYesnoDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogService = /*#__PURE__*/(() => {
  class DialogService {
    constructor(_dialog) {
      this._dialog = _dialog;
    }
    /**
     * Opens a dialog component using MatDialog
     *
     * @param component Dialog component
     * @param title Title of the dialog, which is passed a parameter to the dialog.
     * @param message Message of the dialog, which is passed a parameter to the dialog.
     * @param formatData Format data for ngx-translate, which is passed a parameter to the dialog.
     *
     * @returns Dialogergebnis
     */
    showMessageDialog(component, dialogTitle, dialogMessage, formatData) {
      const dialogRef = this._dialog.open(component, {
        data: {
          title: dialogTitle,
          message: dialogMessage,
          formatData: formatData
        },
        disableClose: true
      });
      return dialogRef.afterClosed();
    }
    /**
     * Opens a Yes / No dialog
     * @param dialogTitle Title of the dialog
     * @param dialogMessage Message of the dialog
     * @param formatData Format data for ngx-translate
     *
     * @returns Returns true for Yes and false for No.
     */
    async showYesNoDialog(dialogTitle, dialogMessage, formatData) {
      let dialog$ = this.showMessageDialog(GenericYesnoDialogComponent, dialogTitle, dialogMessage, formatData).pipe(map(result => !!result));
      let dialogReturn = await lastValueFrom(dialog$);
      if (dialogReturn) return true;
      return false;
    }
    /**
     * Opens a Ok dialog
     * @param dialogTitle Title of the dialog
     * @param dialogMessage Message of the dialog
     * @param formatData Format data for ngx-translate
     *
     * @returns Returns true
     */
    async showOkDialog(dialogTitle, dialogMessage, formatData) {
      let dialog$ = this.showMessageDialog(GenericOkDialogComponent, dialogTitle, dialogMessage, formatData).pipe(map(result => !!result));
      await lastValueFrom(dialog$);
      return true;
    }
    /**
     * Creates a dialog for a component, which implements the IDialog interface.
     * @param component Component to show as dialogs
     * @param data Data which should be passed to the dialog
     * @returns Can return the value of the component.
     */
    async showDialog(component, buttons, size, data, customClasses, buttonAlign) {
      const dialogRef = this._dialog.open(GenericDialogComponent, {
        data: {
          componentType: component,
          data: data,
          buttons: buttons,
          customClasses: customClasses,
          buttonAlign: buttonAlign
        },
        disableClose: true,
        width: size?.width,
        height: size?.height,
        maxHeight: size?.maxHeight,
        maxWidth: size?.maxWidth
      });
      let dialogReturn = await lastValueFrom(dialogRef.afterClosed());
      return dialogReturn;
    }
    static {
      this.ɵfac = function DialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i1.MatDialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DialogService,
        factory: DialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IDialog {
  /**
   * Sets the dialog referenced, which is used to manipulate the dialog.
   * @param dialogRef
   */
  setDialogRef(dialogRef) {
    this._DialogRef = dialogRef;
  }
  /** @return Returns a list of buttons, which should be displayed. */
  getDialogButtons() {
    return [];
  }
  /**
   * Closes the dialog
   * @param result Optional result which is passed to the caller.
   */
  closeDialog(result) {
    this._DialogRef?.close(result);
  }
  /**
   * Allows the change the disable state of a dialog button.
   * @param button
   * @param disabled
   */
  disableButton(button, disabled) {
    this._DialogRef?.componentInstance?.disableButton(button, disabled);
  }
}
var DialogButtonTypes = /*#__PURE__*/function (DialogButtonTypes) {
  DialogButtonTypes["CANCEL"] = "t_cancel";
  DialogButtonTypes["SAVE"] = "t_save";
  DialogButtonTypes["CLOSE"] = "t_close";
  DialogButtonTypes["SELECT"] = "t_select";
  DialogButtonTypes["OK"] = "t_ok";
  DialogButtonTypes["REQUEST"] = "t_request";
  DialogButtonTypes["STORNO"] = "t_storno";
  return DialogButtonTypes;
}(DialogButtonTypes || {});
let FavouriteStarComponent = /*#__PURE__*/(() => {
  class FavouriteStarComponent {
    constructor() {
      this.value = model(false);
    }
    changeValue() {
      this.value.set(!this.value);
    }
    static {
      this.ɵfac = function FavouriteStarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FavouriteStarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FavouriteStarComponent,
        selectors: [["esd-gui-favourite-star"]],
        inputs: {
          value: [1, "value"]
        },
        outputs: {
          value: "valueChange"
        },
        decls: 2,
        vars: 1,
        consts: [["matSuffix", "", 1, "checkmark"], ["matSuffix", "", 1, "checkmark-checked"], ["matSuffix", "", 1, "checkmark", 3, "click"], ["matSuffix", "", 1, "checkmark-checked", 3, "click"]],
        template: function FavouriteStarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FavouriteStarComponent_Conditional_0_Template, 2, 0, "mat-icon", 0)(1, FavouriteStarComponent_Conditional_1_Template, 2, 0, "mat-icon", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.value() ? 0 : 1);
          }
        },
        dependencies: [MatIcon],
        styles: [".checkmark[_ngcontent-%COMP%]{cursor:pointer;display:block;height:30px;width:30px;color:#cfcfcf;transition:.2s ease color;font-size:30px!important}.checkmark[_ngcontent-%COMP%]:after{transition:.2s ease opacity;position:absolute;left:0;top:0;opacity:0;color:#fce72c}.checkmark[_ngcontent-%COMP%]:hover{color:#fce72c}.checkmark-checked[_ngcontent-%COMP%]{cursor:pointer;display:block;height:30px;width:30px;font-size:30px!important;color:#fce72c}"],
        changeDetection: 0
      });
    }
  }
  return FavouriteStarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorHandlerService = /*#__PURE__*/(() => {
  class ErrorHandlerService {
    constructor(_dialogService, _snackbar, _translate) {
      this._dialogService = _dialogService;
      this._snackbar = _snackbar;
      this._translate = _translate;
    }
    /**
     * Handles a http error.
     * @param error HTTP-Error
     * @returns Returns an empty observable.
     */
    handleHTTPError(error) {
      return this.error("http_error." + error.status);
    }
    /**
     * Shows a success message as a snackbar
     * @param message Message to show
     * @param duration Time to show this message.
     */
    success(message, keys, duration = 2000) {
      this._translateMessage(message, keys).subscribe(translated => {
        this._snackbar.open(translated, "", {
          duration: duration,
          verticalPosition: "top",
          panelClass: "success-snackbar"
        });
      });
    }
    /**
     * Shows a message as a snackbar
     * @param message Message to show
     * @param duration Time to show this message.
     */
    message(message, keys, duration = 2000) {
      this._translateMessage(message, keys).subscribe(translated => {
        this._snackbar.open(translated, "", {
          duration: duration,
          verticalPosition: "top"
        });
      });
    }
    error(message, keys, httpMessage) {
      this._translateMessage(message, keys).subscribe(res => this._dialogService.showOkDialog("t_error", res));
      return EMPTY;
    }
    /**
     * Translates a message, which can contains keys.
     * @param message
     */
    _translateMessage(message, keys) {
      if (message !== undefined && keys == undefined) {
        return this._translate.get(message).pipe(map(x => x));
      } else if (keys != undefined) {
        return this._translate.get(keys).pipe(map(translated => {
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (translated.hasOwnProperty(key)) keys[i] = translated[key];
          }
          return this._formatString(message, keys);
        }));
      }
      return of(message);
    }
    /**
     * Formats a string.
     * @param fmt
     * @param keys
     * @returns
     */
    _formatString(fmt, keys) {
      return fmt.replace(/{(\d+)}/g, (match, number) => {
        return typeof keys[number] != 'undefined' ? keys[number] : match;
      });
    }
    static {
      this.ɵfac = function ErrorHandlerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ErrorHandlerService)(i0.ɵɵinject(DialogService), i0.ɵɵinject(i2.MatSnackBar), i0.ɵɵinject(i3.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ErrorHandlerService,
        factory: ErrorHandlerService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ErrorHandlerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GuiOperatorsService = /*#__PURE__*/(() => {
  class GuiOperatorsService {
    constructor(_errorHandler) {
      this._errorHandler = _errorHandler;
    }
    catchHttpErrors(...operations) {
      return source => {
        return source.pipe(catchError(err => this._errorHandler.handleHTTPError(err)), ...operations, shareReplay(1));
      };
    }
    static {
      this.ɵfac = function GuiOperatorsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GuiOperatorsService)(i0.ɵɵinject(ErrorHandlerService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GuiOperatorsService,
        factory: GuiOperatorsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GuiOperatorsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of gui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DialogButtonTypes, DialogService, ErrorHandlerService, FavouriteStarComponent, GuiOperatorsService, IDialog };
